<template>
  <div>
    <div class="section-contact justify-center">
      <v-container grid-list-lg>
        <!------------------------------------------OptIn------------------------------------------>
        <v-row row>
          <v-col
            xs="4"
            md="4"
            lg="4"
          >
            <phone-number-input
              v-model="optIn.phone"
              :input-id="'phone'"
              :options="{showDialCode: true}"
              :preferred-countries="['IT', 'FR', 'BE', 'DE']"
              color="#b71c1c"
              default-country-code="IT"
              label="ENTER YOUR PHONE NUMBER"
            />
          </v-col>
        </v-row>

        <v-row row>
          <v-col xs="6">
            <v-switch
              v-model="optIn.enabled"
              :label="`Activate Opt-in Module`"
              class="background-grey"
              color="#b71c1c"
            />
          </v-col>
        </v-row>
        <div v-if="optIn.enabled">
          <a :href="activatedUrl"> {{ activatedUrl }} </a>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import PhoneNumberInput from 'vue3-phone-number-input';
import 'vue3-phone-number-input/dist/vue3-phone-number-input.css';

export default {
  name: 'OptIn',
  components: {
    PhoneNumberInput,
  },
  props: ['institution'], // eslint-disable-line vue/require-prop-types
  data() {
    return {};
  },
  computed: {
    optIn() {
      return this.$props.institution.preferences.optIn || {};
    },
    activatedUrl() { return this.$props.institution.shop; },
  },
  methods: {},
};
</script>

<style scoped>
.sms-sent {
  margin: 20px;
  background-color: green;
  color: white;
  padding: 10px;
  border-radius: 5px;
}
</style>
